import * as React from 'react';
import { useSliderContext } from './sliderContext';
export function useSlideContextBuilder(index) {
  var _useSliderContext = useSliderContext(),
      currentSlide = _useSliderContext.currentSlide;

  var isActive = currentSlide === index;
  return React.useMemo(function () {
    return {
      isActive: isActive
    };
  }, [isActive]);
}